export const OPEN_SHARE_MODAL = "OPEN_SHARE_MODAL";
export const CLOSE_SHARE_MODAL = "CLOSE_SHARE_MODAL";
export const SET_LINK = "SET_LINK";
export const REMOVE_LINK = "REMOVE_LINK";
export const COPY = "COPY";

export const open = () => {
  return dispatch => {
    dispatch({ type: OPEN_SHARE_MODAL });
  };
};

export const close = () => {
  return dispatch => {
    dispatch({ type: CLOSE_SHARE_MODAL });
  };
};

export const setLink = link => {
  return dispatch => {
    dispatch({ type: SET_LINK, link: link });
  };
};

export const removeLink = () => {
  return dispatch => {
    dispatch({ type: REMOVE_LINK });
  };
};

export const copy = () => {
  return dispatch => {
    dispatch({ type: COPY });
  };
};
